/**
 * THE CONSENT CSV — generated on request, handed straight to the browser.
 *
 * Nothing is emailed or sent anywhere: the file is built by the server for the
 * organization being viewed and saved by this browser only.
 */
import api from '../../lib/api';

export const downloadConsentCsv = async (organizationId, memberId = '') => {
    const r = await api.get('/loyalty/consent.csv', {
        params: { organization_id: organizationId, member_id: memberId || undefined },
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([r.data], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = memberId ? `consent-${memberId}.csv` : 'consent-records.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};
